(function () {
  'use strict';

  const $ = window.jQuery;

  function StaffDirectoryFilters() {
    this.initStaffDropdown();
    this.initCoachesDropdown();
  }

  StaffDirectoryFilters.prototype.initStaffDropdown = function () {
    $(document).on('change', '#department_filter', function () {
      const selectedDepartment = $(this).val()
      const staffDirectoryTables = $('[data-department-id]')

      staffDirectoryTables.show()

      if (selectedDepartment) {
        staffDirectoryTables.not(`[data-department-id="${selectedDepartment}"]`).hide();
      }
    })
  };

  StaffDirectoryFilters.prototype.initCoachesDropdown = function () {
    $(document).on('change', '#coach_sport_category_filter', function () {
      const selectedSportCategory = $(this).val()
      const coachesSportCategoriesTables = $('[data-coach-sport-category-id]')

      coachesSportCategoriesTables.show()

      if (selectedSportCategory) {
        coachesSportCategoriesTables.not(`[data-coach-sport-category-id="${selectedSportCategory}"]`).hide();
      }
    })
  };

  window.StaffDirectoryFilters = StaffDirectoryFilters;

}());
